import styled from '@emotion/styled';
import { Check, UsbRounded, WidthFull } from '@mui/icons-material';
import {  Form, Input, Tooltip} from 'antd';
import Checkbox, { CheckboxChangeEvent } from 'antd/es/checkbox/Checkbox';
import { useState } from 'react';

const CheckBox = (props:{label?:string,name?:string,error?:string, width? : number, placeholder?: string, notRequired? : true, title? : string, maxLength? : number, minLength? : number, icon?: any, form?: any, onChange?: any, onClick?: any, disabled? :boolean, checked?: boolean}) => {
  let notR = props.notRequired? false : true
  
  const[val, setVal] = useState(false)

  function handleChange() {
    let val = props.form.getFieldValue(props.name)
    if(val == false){
        props.form.setFieldValue(props.name, true)
    }
    else if(val == true){
        props.form.setFieldValue(props.name, false)
    }
    else{
        props.form.setFieldValue(props.name, true)
    }
  }
  return (
    <div className='checkbox'>
        <Form.Item
           preserve={true}
            labelCol={{ span: props.width }}
            label={props.label} 
            className='bordure'
            name={props.name}
            valuePropName="checked"
            rules={[{ required: notR, message: '' }]}>
              <Checkbox 
              onClick={props.onClick} 
              onChange={props.onChange} 
              disabled={props.disabled} 
              style={{top:-3, marginRight: 10}} /> 
            {/* <Input defaultValue={"false"} disabled addonBefore={props.icon}  maxLength={props.maxLength} minLength={props.minLength} type={"boolean"} placeholder={props.placeholder} /> */}
        </Form.Item>
    </div>
  );
}

export default CheckBox;